import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemEntity } from '../../domain/entities/ItemEntity'
import type { ItemAdminDto } from '@/backend/market'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { CategoryMiniEntity } from '@/features/category/domain/entities/CategoryMiniEntity'
import { getImageFullUrl } from '@/utils/getImageFullUrl'
import type { ItemUnitMiniEntity } from '@/features/ItemUnits/domain/entities/ItemUnitsMiniEntity'
export class ItemModel extends ItemEntity {
  itemUnit?: ItemUnitMiniEntity | null;

  constructor(dataDto: ItemAdminDto, branch: BranchMiniEntity, category: CategoryMiniEntity) {
    const result = {
      ...dataDto,
      branch,
      category
    }
    super()
    mapEntityProperties<ItemEntity>(this, result, {
      map: {
        itemUnit: {
          id: dataDto.unit?.id,
          title: dataDto.unit?.title
        },
        itemGalleries: dataDto.itemGalleries
          ?.map((item) => {
            return {
              ...item,
              imageUrl: getImageFullUrl(item.imageUrl ?? ''),
              order: item.order || 0
            }
          })
          .sort((a, b) => a.order - b.order)
      }
    })
  }
}
